import { Types } from "../actions/userGroupActions";

const initialState = {
    userGroups: {},
    plants: {},
    userGroup: [],
    userPoolGroup: {},
    userupdatedPoolGroup: {},
    userGrouploading: false,
    isTaskUpdatedUserGroup: false,
};

export const userGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_USER_GROUPS:
            return {
                ...state,
                userGroups: action.payload ?? state.userGroups,
            };
        case Types.SET_PLANTS:
            return {
                ...state,
                plants: action.payload ?? state.plants,
            };
        case Types.SET_USER_GROUP_BY_ID:
            return {
                ...state,
                userGroup: action.payload,
                userGrouploading: false,
            };
        case Types.SET_POOL_LIST:
            return {
                ...state,
                userPoolGroup: action.payload,
                userGrouploading: false,
            };
        case Types.SET_POOL_USER_GROUP:
            return {
                ...state,
                userupdatedPoolGroup: action.payload,
                userGrouploading: false,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedUserGroup: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedUserGroup: false,
            };
        default:
            return state;
    }
};
